import { render, staticRenderFns } from "./NewsSideBar.vue?vue&type=template&id=4e9c9bc1&scoped=true"
import script from "./NewsSideBar.vue?vue&type=script&lang=js"
export * from "./NewsSideBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9c9bc1",
  null
  
)

export default component.exports